<template>
  <div class="exam-history">
    <HDFHeader03 />

    <div class="page-wrapper">
      <el-container>
        <el-header class="page-header">
          <h1>我的报名历史</h1>
          <el-button type="primary" @click="$router.push('/exam-list')" plain>
            返回考试列表
          </el-button>
        </el-header>
        
        <el-main>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-alert
                title="以下是您历史报名记录"
                type="info"
                :closable="false"
                show-icon
                class="info-alert"
              />
            </el-col>
          </el-row>
          
          <el-tabs v-model="activeTab" class="history-tabs">
            <el-tab-pane label="全部记录" name="all">
              <el-timeline class="history-timeline">
                <el-timeline-item
                  v-for="(record, index) in historyRecords"
                  :key="index"
                  :timestamp="record.createTime"
                  placement="top"
                  :type="getTimelineType(record.status)"
                >
                  <el-card class="history-card">
                    <div class="history-card-header">
                      <h3>{{ record.createTime }}</h3>
                      <el-tag :type="getStatusTagType(record.status)">
                        {{ getStatusText(record.status) }}
                      </el-tag>
                    </div>
                    
                    <div class="history-card-content">
                      <div class="exam-info-grid">
                        <div class="info-item">
                          <div class="info-label">考试等级</div>
                          <div class="info-value">{{ getLevelText(record.level) }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">编程语言</div>
                          <div class="info-value">{{ record.lang }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">报名时间</div>
                          <div class="info-value">{{ record.examSession.registrationStartDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试时间</div>
                          <div class="info-value">{{ record.examSession.registrationEndDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试地点</div>
                          <div class="info-value">{{ record.examSession.locationDescription }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">准考证号</div>
                          <div class="info-value">{{ record.admissionTicket || '待生成' }}</div>
                        </div>
                      </div>
                      
                      <div class="history-card-actions">
                        <el-button 
                          size="small"
                          type="primary"
                          v-if="record.payState === 0"
                        >
                          支付报名费
                        </el-button>
                        <el-button 
                          v-if="record.status === 'sub_success'" 
                          size="small"
                          @click="viewAdmitCard(record)"
                        >
                          查看准考证
                        </el-button>
                        <el-button 
                          v-if="record.status === 'exam_finish'" 
                          size="small"
                          @click="viewResults(record)"
                        >
                          查看成绩
                        </el-button>
                        <el-button 
                          v-if="record.status === 'enabled'" 
                          size="small"
                          type="danger"
                          plain
                          @click="cancelRegistration(record)"
                        >
                          取消报名
                        </el-button>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            
            <!-- <el-tab-pane label="报名成功" name="success">
              <el-timeline class="history-timeline">
                <el-timeline-item
                  v-for="(record, index) in getFilteredRecords('报名成功')"
                  :key="index"
                  :timestamp="record.timestamp"
                  placement="top"
                  type="primary"
                >
                  <el-card class="history-card">
                    <div class="history-card-header">
                      <h3>{{ record.examTitle }}</h3>
                      <el-tag type="success">报名成功</el-tag>
                    </div>
                    
                    <div class="history-card-content">
                      <div class="exam-info-grid">
                        <div class="info-item">
                          <div class="info-label">考试等级</div>
                          <div class="info-value">{{ record.level }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">编程语言</div>
                          <div class="info-value">{{ record.language }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">报名时间</div>
                          <div class="info-value">{{ record.registrationDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试时间</div>
                          <div class="info-value">{{ record.examDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试地点</div>
                          <div class="info-value">{{ record.location }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">准考证号</div>
                          <div class="info-value">{{ record.admissionTicket || '待生成' }}</div>
                        </div>
                      </div>
                      
                      <div class="history-card-actions">
                        <el-button size="small" @click="viewAdmitCard(record)">
                          查看准考证
                        </el-button>
                        <el-button 
                          size="small"
                          type="danger"
                          plain
                          @click="cancelRegistration(record)"
                        >
                          取消报名
                        </el-button>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            
            <el-tab-pane label="待考试" name="upcoming">
              <el-timeline class="history-timeline">
                <el-timeline-item
                  v-for="(record, index) in getFilteredRecords('报名成功')"
                  :key="index"
                  :timestamp="record.timestamp"
                  placement="top"
                  type="primary"
                >
                  <el-card class="history-card">
                    <div class="history-card-header">
                      <h3>{{ record.examTitle }}</h3>
                      <el-tag type="success">报名成功</el-tag>
                    </div>
                    
                    <div class="history-card-content">
                      <div class="exam-info-grid">
                        <div class="info-item">
                          <div class="info-label">考试等级</div>
                          <div class="info-value">{{ record.level }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">编程语言</div>
                          <div class="info-value">{{ record.language }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">报名时间</div>
                          <div class="info-value">{{ record.registrationDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试时间</div>
                          <div class="info-value">{{ record.examDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试地点</div>
                          <div class="info-value">{{ record.location }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">准考证号</div>
                          <div class="info-value">{{ record.admissionTicket || '待生成' }}</div>
                        </div>
                      </div>
                      
                      <div class="history-card-actions">
                        <el-button size="small" @click="viewAdmitCard(record)">
                          查看准考证
                        </el-button>
                        <el-button 
                          size="small"
                          type="danger"
                          plain
                          @click="cancelRegistration(record)"
                        >
                          取消报名
                        </el-button>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            
            <el-tab-pane label="已完成" name="completed">
              <el-timeline class="history-timeline">
                <el-timeline-item
                  v-for="(record, index) in getFilteredRecords('考试已结束')"
                  :key="index"
                  :timestamp="record.timestamp"
                  placement="top"
                  type="success"
                >
                  <el-card class="history-card">
                    <div class="history-card-header">
                      <h3>{{ record.examTitle }}</h3>
                      <el-tag type="info">考试已结束</el-tag>
                    </div>
                    
                    <div class="history-card-content">
                      <div class="exam-info-grid">
                        <div class="info-item">
                          <div class="info-label">考试等级</div>
                          <div class="info-value">{{ record.level }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">编程语言</div>
                          <div class="info-value">{{ record.language }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">报名时间</div>
                          <div class="info-value">{{ record.registrationDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试时间</div>
                          <div class="info-value">{{ record.examDate }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试地点</div>
                          <div class="info-value">{{ record.location }}</div>
                        </div>
                        
                        <div class="info-item">
                          <div class="info-label">考试成绩</div>
                          <div class="info-value">{{ record.score || '待发布' }}</div>
                        </div>
                      </div>
                      
                      <div class="history-card-actions">
                        <el-button size="small" @click="viewResults(record)">
                          查看成绩
                        </el-button>
                        <el-button size="small" @click="viewCertificate(record)">
                          查看证书
                        </el-button>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane> -->
          </el-tabs>
          
          <el-row v-if="historyRecords.length == 0" justify="center" class="empty-state">
            <el-empty description="暂无报名记录" />
          </el-row>
        </el-main>
      </el-container>
    </div>

    <HDFFooter03 />
    
    <!-- 准考证对话框 -->
    <el-dialog
      v-model="admitCardDialogVisible"
      title="准考证信息"
      width="500px"
      append-to-body
    >
      <div class="admit-card-preview" v-if="selectedRecord">
        <div class="admit-card-header">
          <h3>{{ selectedRecord.examTitle }}</h3>
          <p>准考证号: {{ selectedRecord.admissionTicket }}</p>
        </div>
        
        <div class="admit-card-info">
          <div class="info-row">
            <span class="label">考生姓名:</span>
            <span class="value">{{ selectedRecord.userName }}</span>
          </div>
          
          <div class="info-row">
            <span class="label">考试时间:</span>
            <span class="value">{{ selectedRecord.examDate }}</span>
          </div>
          
          <div class="info-row">
            <span class="label">考试地点:</span>
            <span class="value">{{ selectedRecord.location }}</span>
          </div>
          
          <div class="info-row">
            <span class="label">座位号:</span>
            <span class="value">{{ selectedRecord.seatNumber }}</span>
          </div>
          
          <div class="info-row">
            <span class="label">注意事项:</span>
            <span class="value note">请携带有效身份证件和准考证参加考试</span>
          </div>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="admitCardDialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="printAdmitCard">打印准考证</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { apiGetExamInfoList } from '@/api/exam'

import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'

const activeTab = ref('all')

// 报名历史记录数据
const historyRecords = ref([])

// 获取时间线类型
const getTimelineType = (status) => {
  const typeMap = {
    '报名成功': 'primary',
    '考试已结束': 'success',
    '已取消': 'danger'
  }
  return typeMap[status] || 'info'
}

// 获取状态标签类型
const getStatusTagType = (status) => {
  const statusMap = {
    'exam_finished': 'success',
    'enable': 'info',
    'cancel': 'danger'
  }
  return statusMap[status] || 'info'
}

const getStatusText = (status) => {
  const statusMap = {
    'exam_finished': '考试已结束',
    'enable': '报名中',
    'cancel': '已取消',
    'sub_success': '报名成功'
  }
  return statusMap[status] || '报名成功'
}

const getLevelText = (level) => {
  const levelMap = {
    '1': '一级',
    '2': '二级',
    '3': '三级',
    '4': '四级',
    '5': '五级',
    '6': '六级',
    '7': '七级',
    '8': '八级',
    '9': '九级'

  }
  return levelMap[level] || '初级'
}

// 筛选记录
const getFilteredRecords = (status) => {
  return historyRecords.value.filter(record => record.status === status)
}

// 准考证对话框
const admitCardDialogVisible = ref(false)
const selectedRecord = ref(null)

// 查看准考证
const viewAdmitCard = (record) => {
  selectedRecord.value = record
  admitCardDialogVisible.value = true
}

// 打印准考证
const printAdmitCard = () => {
  ElMessage.info('打印功能演示')
  admitCardDialogVisible.value = false
}

// 查看成绩
const viewResults = (record) => {
  ElMessage.success(`查看 ${record.examTitle} 的成绩`)
}

// 查看证书
const viewCertificate = (record) => {
  ElMessage.success(`查看 ${record.examTitle} 的证书`)
}

// 取消报名
const cancelRegistration = (record) => {
  ElMessageBox.confirm(
    `确定要取消"${record.examTitle}"的报名吗？取消后将无法恢复。`,
    '确认取消',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      record.status = '已取消'
      ElMessage.success('已取消报名')
    })
    .catch(() => {
      // 用户取消操作
    })
}


onMounted(() => {
  apiGetExamInfoList().then(response => {
    const res = response.data
    historyRecords.value = res.data
  })
})

</script>

<style scoped>
.exam-history {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.page-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.page-header h1 {
  margin: 0;
  color: #303133;
}

.info-alert {
  margin-bottom: 20px;
}

.history-tabs {
  margin-top: 20px;
}

.history-timeline {
  padding: 20px 0;
}

.history-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.history-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.history-card-header h3 {
  margin: 0;
  color: #303133;
}

.exam-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.info-item .info-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 3px;
}

.info-item .info-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.history-card-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.empty-state {
  margin-top: 50px;
}

.admit-card-preview {
  border: 1px dashed #409eff;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
}

.admit-card-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.admit-card-header h3 {
  margin: 0 0 10px 0;
  color: #303133;
}

.admit-card-header p {
  margin: 0;
  color: #606266;
  font-weight: 500;
}

.info-row {
  display: flex;
  margin-bottom: 12px;
}

.info-row .label {
  width: 80px;
  color: #909399;
  font-size: 14px;
}

.info-row .value {
  flex: 1;
  color: #303133;
  font-size: 14px;
}

.info-row .value.note {
  color: #e6a23c;
  font-size: 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 15px;
  }
  
  .exam-info-grid {
    grid-template-columns: 1fr;
  }
  
  .history-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .page-wrapper {
    padding: 0 10px;
  }
}
</style>